import axios from '../axios';

export const fetchAllWithdrawals = (payload) => axios.post('/withdraw', payload);
